import Papa from 'papaparse'

export const buildBlastRecipientCsv = (recipients) =>
	Papa.unparse(recipients.map((recipient) => {
		const checkIn = recipient.checkIn || {}
		return {
			'Recipient ID': recipient.id,
			'Check-in ID': recipient.checkInId || '',
			'Traveler': checkIn.travelerName || recipient.travelerName || '',
			'Account': checkIn.accountName || '',
			'Booking number': checkIn.bookingNumber || '',
			'SMS number': checkIn.travelerPhone || '',
			'Email': checkIn.travelerEmail || '',
			'Station': checkIn.station?.name || '',
			'Segment': checkIn.segment?.name || '',
			'Scheduled check-in': checkIn.scheduledCheckInDate || '',
			'Check-out date': checkIn.checkOutDate || '',
			'Checked in': checkIn.checkInStatus == null ? '' : checkIn.checkInStatus,
			'Actual check-in': checkIn.actualCheckInDateTime || '',
			'Address': recipient.address || '',
			'Channel': recipient.channel || '',
			'Status': recipient.status || '',
			'Sent': recipient.sentAt || '',
			'Delivered': recipient.deliveredAt || '',
			'Opened': recipient.openedAt || '',
			'Bounced': recipient.bouncedAt || '',
			'Error code': recipient.errorCode || '',
			'Error message': recipient.errorMessage || '',
		}
	}), { escapeFormulae: true })
